module.exports = __webpack_public_path__ + "static/media/step_005.1a6e6d86.jpeg";